import React from 'react'

function FinanceiroIndex() {
  return (
    <div>FinanceiroIndex</div>
  )
}

export default FinanceiroIndex